import { StudentReviewsList } from './StudentReviewsList';

export const list = StudentReviewsList;
